import { withStyles, getContrastColor, MaterialSymbol } from 'vopay';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useLayout } from '@/providers/Layout.provider';
import styles from './AccountType.module.scss';
const cn = withStyles(styles);
function AccountType({
  value,
  name,
  disabled,
  onChange,
}: {
  value: 'personal' | 'business';
  name: string;
  disabled: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}) {
  const { color } = useLayout();
  const { t } = useTranslation('translations', { keyPrefix: 'BankConnection' });
  const selectedTextColor = getContrastColor(color);
  return (
    <div
      className={cn('typeButtonContainer', disabled && 'disabled')}
      style={{
        '--selectedBgColor': color,
        '--selectedTextColor': selectedTextColor,
      }}
    >
      <label className={cn('button')}>
        <MaterialSymbol icon="check" size="24px" className={cn('check')} />
        <span>{t('personalButton', { defaultValue: 'Personal' })}</span>
        <input name={name} type="radio" value="personal" checked={value === 'personal'} onChange={onChange} />
      </label>
      <label className={cn('button')}>
        <MaterialSymbol icon="check" size="24px" className={cn('check')} />
        <span>{t('businessButton', { defaultValue: 'Business' })}</span>
        <input name={name} type="radio" value="business" checked={value === 'business'} onChange={onChange} />
      </label>
    </div>
  );
}
export default AccountType;
